import DatePickerLocale from "antd/es/date-picker/locale/en_US";
import { IObjectMap } from "../interfaces/common";

export const HEADER = {
  logoAlt: "Logo",
  declarant: "Declarant",
  created: "Created",
  taxFree: "TaxFree",
  window: "Windows",
  logout: "Logout",
  deleted: "Deleted",
  departmentsData: "Departments Data",
  byClients: "By Clients",
  changePassword: "Change Password",
  groupBy: "Group By",
  cashbox: "Cashbox",
  cmr: "CMR",
  sigma: "Sigma",
  logistic: "Logistic",
  contracts: "Contracts",

  fleetExpenses: "Fleet Expenses",
};

export const TABLE_HEADER = {
  searchPlaceholder: "Search",
};

export const TABLE_COLUMNS = {
  epi: "EPI",
  creator: "Creator",
  created_at: "Created At",
  department: "Department",
  client: "Client",
  means_of_transportation: "TC",
  carrier: "Carrier",
  driver: "Driver",
  consignor: "Consignor",
  consignment_items: "TNVED",
  invoice: "Inv.",
  currency: "Curr.",
  cargo_quantity: "CL",
  brutto: "Brutto",
  cmr: "CMR",
  date_cmr: "Date CMR",
  border_checkpoint_name: "Departure Customs",
  internal_note: "Internal Note",
  note: "Note",
  mistakes: "Mistakes",
  user: "User",
  measure_code: "Measure Code",
  measure_code_doc_number: "Measure Code Doc Number",
  warranty: "Warranty",
  way: "Way",
  services: "Services",
  services_cost: "Services Cost",
  customs_code: "Custom Code",
  customs_code_and_office_name: "Destination Customs",
  exposed: "Exposed",
  INDEX: "#",
  actions: "Actions",
  changed_column: "Changed Column",
  cert_status: "Cert. Status",
} as IObjectMap;

export const DEPARTMENT_DATA_TABLE_COLUMNS = {
  one_code: "1th Code",
  next_code: "Next Code",
  guarantee_cost: "Warranty Cost",
  form_payment: "Payment",
  usd: "USD",
  eur: "EUR",
  pln: "PLN",
  invoice_number: "Invoice Number",
  epi_cost: "EPI Cost",
  t1: "T1",
  total_cost: "Total Cost",
} as const;

export const DEPARTMENT_DATA_SERVICES = {
  title: "Department Data Services",
  viewTitle: "Applied services",
  service: "Service",
  serviceIdRequired: "Service id is required",
  selectService: "Select a service",
  amount: "Amount",
  amountRequired: "Amount is required",
  amountFormat: "Enter a non-negative amount with up to 2 decimal places (maximum 999999999999.99)",
  enterAmount: "Enter amount",
  remove: "Remove service",
  edit: "Edit services",
  view: "View services",
  cancel: "Cancel",
  save: "Save",
  close: "Close",
  add: "Add service",
  loading: "Loading services...",
  loadError: "Unable to load services.",
  incompleteFormError: "Complete each service and amount before saving.",
  archived: "Archived",
  currency: "EUR",
} as const;

export const CASHBOX_TABLE_COLUMNS = {
  action: "Action",
  employee: "Employee",
  date: "Date",
  usd: "USD",
  eur: "EUR",
  pln: "PLN",
  comment: "Comment",
};

export const FILTERS_SECTION = {
  startDate: "Start Date",
  endDate: "End Date",
  upload: "Upload XML",
};

export const TABLE_SETTINGS = {
  can_reorder_columns: "Can reorder table columns?",
  can_visible_scrollbar: "Show table scrollbar?",
};

export const MODAL = {
  confirm_title: "Are you sure?",
  confirm_save: "Do you want save that entity?",
  confirm_delete: "Do you want delete that entity?",
  confirm_clear: "Do you want delete all deleted entities?",
  confirm_restore: "Do you want restore deleted entities?",
  info_title: "Attention",
  info_delete_checker: "Logistic row cannot be deleted. It has child elements",
  confirm_delete_custom_entity: (entity: string): string =>
    `Do you want to delete this ${entity}?`,
};

export const BUTTONS = {
  clearTable: "Clear Table",
};

export const CREATE_BUTTON = "Create";
export const CHANGE_BUTTON = "Change";
export const CANCEL_BUTTON = "Cancel";

export const MANUAL_BUTTON = "Manual";
export const CALCULATE = "Calculate";

export const DOWNLOAD = "Download XML";
export const GROUP_BUTTON = "Make custom group";
export const GROUP_BUTTON_DEPARTMENTS_DATA = "Make group";
export const UNGROUP_BUTTON = "Remove items from custom group";
export const UNGROUP_BUTTON_DEPARTMENTS_DATA = "Remove from group";
export const JOIN_BUTTON = "Join";
export const GENERATE_INVOICE_BUTTON = "Generate Invoice";
export const GENERATE_REGISTER_OF_ACCOUNTS_BUTTON = "Register of Accounts";

export const HAND_OVER_CASH = "Hand Over Cash";
export const HAND_OVER = "Hand Over";
export const HAND_OVER_ANYWAY = "Hand Over Anyway";
export const ACCEPT_CASH = "Accept Cash";
export const TOP_UP_TO_CASH = "Top Up to Cash";
export const TAKE_FROM_CASH = "Take from Cash";

export const CREATE_CMR = "Create new CMR";
export const UPDATE_CMR = "Update Cmr";
export const SAVE_CMR_DOWNLOAD_PDF = "Save and Download PDF";
export const EXPORT_TO_EXCEL = "Export to Excel";
export const CUSTOM_EXPORT_TO_EXCEL = "Custom Export";

export const DATEPICKER_LOCALE = DatePickerLocale;

export const CMR_TABLE_COLUMNS = {
  cmr_number: "CMR Number",
  department: "Department",
  creator: "Creator",
  cmr_date: "CMR Date",
  created_at: "Created At",
  carrier: "Carrier",
  consignor: "Consignor",
  recipient: "Recipient",
  destination_customs: "Destination Customs",
  brutto: "Brutto",
  cll: "CLL",
  invoice_number: "Inv.",
  actions: "Actions",
};

export const LOGISTIC_TABLE_COLUMNS = {
  internalNo: "Internal No.",
  loading_date: "Date",
  docs_sent_date: "Docs Sent Date",
  tc: "TC",
  fv: "FV",
  way: "Way",
  note: "Note",
  amount: "Amount",
  currency: "Currency",
  payment_date: "Payment Date",
  is_paid: "Is Paid",
  is_ready: "Is Ready",
  client: "Client",
  contractor: "Contractor",
  documents: "Documents",
  actions: "Actions",
  cost: "Cost",
};

export const CONTRACTS_TABLE_COLUMNS = {
  INDEX: "#",
  companyName: "Company Name",
  createdDate: "Created Date",
  country: "Country",
  unp: "UNP",
  contract: "Contract №",
  note: "Note",
  status: "Status",
  banOnRegistration: "Ban On Registration",
  documents: "Documents",
  actions: "Actions",
};

export const FLEET_EXPENSES_TABLE_COLUMNS = {
  id: "ID",
  driver: "Driver",
  card: "Card",
  noCard: "No card",
  tc: "TC",
  spendingType: "Spending Type",
  date: "Date",
  amount: "Amount",
  currency: "Currency",
  paymentType: "Payment Type",
  actions: "Actions",
  note: "Note",
};

export const ADD_ROW = "Add a row";

export const DELETE_FILE_MESSAGE = (fileName: string): string =>
  `Do you want delete ${fileName}?`;
